var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 24,
    viewBox: "0 0 144 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.8494 7.38052H34.5703V4.31479H48.5715V7.5995H43.2923V19.2055H39.8494V7.38052Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7848 18.9865V4.09581H55.2277V9.7893H62.8021V4.09581H66.0155V18.9865H62.8021V13.293H55.2277V18.9865H51.7848Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4584 18.7675V4.09581H83.6891V7.5995H72.6718V15.4828H83.6891V18.7675H69.4584Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7214 13.293L75.1966 10.0083H83.6891V13.293H77.7214Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.101 4.31479V7.5995H96.0836C94.9359 7.5995 94.9359 8.25644 94.9359 8.6944C94.9359 9.13236 94.9359 9.7893 96.0836 9.7893H104.117C106.183 9.7893 107.101 12.855 107.101 14.6069C107.101 16.3587 105.724 18.7675 104.347 18.7675C103.245 18.7675 95.4715 18.9135 91.7225 18.9865V15.2638H102.74C104.347 15.2638 104.117 13.074 102.74 13.074H94.7064C92.4111 13.074 91.7225 10.0083 91.7225 8.6944C91.7225 7.38052 92.4111 4.31479 94.4769 4.31479H107.101Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M125.463 8.6944H122.25C122.25 7.5995 121.102 7.16154 118.118 7.16154C115.134 7.16154 113.987 7.81848 113.987 8.91338V14.3879C113.987 15.4828 114.675 15.9208 118.348 15.9208C121.286 15.9208 122.02 14.8988 122.02 14.3879H125.463C125.463 17.4536 122.709 18.9865 118.348 18.9865C113.987 18.9865 110.773 17.8916 110.773 16.3587V8.03746C110.773 6.94256 111.003 3.87683 118.348 3.87683C124.224 3.87683 125.54 7.08854 125.463 8.6944Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M130.917 4.31479H127.244L134.13 18.7675H137.344L144 4.31479H140.786L135.737 14.3879L130.917 4.31479Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1239 4.45632L7.50623 11.8071L11.4158 15.5796L19.0335 8.22887L22.7416 11.8071L11.3708 22.7795L0 11.8071L11.3708 0.834717L15.1239 4.45632Z",
    fill: "#F29418"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.248 11.8074L18.877 22.78L15.124 19.158L22.7422 11.8074L19.0371 8.23315L11.4189 15.5837L7.50586 11.8074L18.877 0.834717L30.248 11.8074Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLogo);
export default __webpack_public_path__ + "static/media/white-logo.55a5dbd4bfae4b89cdfbd55fa4e6628a.svg";
export { ForwardRef as ReactComponent };